"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeDateTimePicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../hooks");
var _Menu = require("../../Menu");
var _dates = require("../../../utilities/dates");
var _RangeDatePicker = require("../RangeDatePicker");
var _TimePickerArea = require("./partials/TimePickerArea");
var _DateTimePickers = require("../DateTimePickers.labels");
var _RangeDateTimePicker = _interopRequireDefault(require("./RangeDateTimePicker.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const getValidProps = props => {
  const {
    startDateTime: startDateTimeProp,
    endDateTime: endDateTimeProp,
    minDateTime: minDateTimeProp,
    maxDateTime: maxDateTimeProp,
    deltaHours: deltaHoursProp,
    minutesStep
  } = props;
  let minDateTime = minDateTimeProp ? (0, _dates.restrictToMinuteStep)(new Date(minDateTimeProp), minutesStep, true) : undefined;
  let maxDateTime = maxDateTimeProp ? (0, _dates.restrictToMinuteStep)(new Date(maxDateTimeProp), minutesStep, false) : undefined;
  if (minDateTime && maxDateTime && minDateTime > maxDateTime) {
    minDateTime = maxDateTime;
  }
  const deltaHours = deltaHoursProp && deltaHoursProp > 0 ? deltaHoursProp : 2;
  const nowDateTime = new Date();
  const futureDateTime = new Date();
  futureDateTime.setHours(futureDateTime.getHours() + deltaHours);
  const defaultStartDate = minDateTime && nowDateTime < minDateTime ? minDateTime : nowDateTime;
  const defaultEndDate = maxDateTime && nowDateTime > maxDateTime ? maxDateTime : futureDateTime;
  let startDateTime = startDateTimeProp ? startDateTimeProp : defaultStartDate;
  let endDateTime = endDateTimeProp && startDateTime <= endDateTimeProp ? endDateTimeProp : (0, _dates.restrictToMinDate)(endDateTimeProp ?? defaultEndDate, startDateTime);

  // TODO: Temporary removed because test automation failure. should fix automation and back to this version in the future!
  //startDateTime = restrictToMinuteStep(startDateTime, minutesStep);
  //endDateTime = restrictToMinuteStep(endDateTime, minutesStep);

  return {
    ...props,
    startDateTime,
    endDateTime,
    minDateTime,
    maxDateTime
  };
};
const RangeDateTimePicker = props => {
  const styles = (0, _RangeDateTimePicker.default)();
  const getLabel = (0, _hooks.useLabels)({
    labels: _DateTimePickers.labels
  });
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    startDateTime,
    endDateTime,
    minDateTime,
    maxDateTime,
    anchorSubTextStartDate,
    anchorSubTextStartTime,
    deltaHours,
    minutesStep,
    anchorSubTextEndDate,
    anchorSubTextEndTime,
    dateTitle,
    startTimeTitle,
    endTimeTitle,
    isDisabled,
    attachedTo = 'StartEndDates',
    btnProps: defaultBtnProps,
    onChange
  } = getValidProps(props);
  const startDateTimestamp = (0, _react.useRef)();
  const endDateTimestamp = (0, _react.useRef)();
  const [currentRangeDates, setCurrentRangeDates] = (0, _react.useState)([startDateTime, endDateTime]);
  const [currentStartDateTime, setCurrentStartDateTime] = (0, _react.useState)(startDateTime);
  const [currentEndDateTime, setCurrentEndDateTime] = (0, _react.useState)(endDateTime);
  const [minStartTime, setMinStartTime] = (0, _react.useState)();
  const [maxStartTime, setMaxStartTime] = (0, _react.useState)();
  const [minEndTime, setMinEndTime] = (0, _react.useState)();
  const [maxEndTime, setMaxEndTime] = (0, _react.useState)();
  const btnProps = {
    color: 'basic',
    view: 'outlined',
    shape: isMobileView ? 'roundedRectangle' : 'ellipse',
    customStyle: {
      height: 'unset',
      width: isMobileView ? '100%' : 'auto'
    },
    isDisabled,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-RangeDateTimePicker__anchor-btn'],
      children: [(attachedTo === 'StartDate' || attachedTo === 'StartEndDates') && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: (0, _dates.formatDate)(startDateTime, '{day}.{month}.{year}')
          }), anchorSubTextStartDate && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: anchorSubTextStartDate
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: (0, _dates.formatDate)(startDateTime, '{hour}:{minute}')
          }), anchorSubTextStartTime && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: anchorSubTextStartTime
          })]
        })]
      }), attachedTo === 'StartEndDates' && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {}), (attachedTo === 'EndDate' || attachedTo === 'StartEndDates') && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: (0, _dates.formatDate)(endDateTime, '{day}.{month}.{year}')
          }), anchorSubTextEndDate && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: anchorSubTextEndDate
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: (0, _dates.formatDate)(endDateTime, '{hour}:{minute}')
          }), anchorSubTextEndTime && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: anchorSubTextEndTime
          })]
        })]
      })]
    }),
    ...defaultBtnProps
  };
  const updateMinMaxTimeValues = (0, _react.useCallback)((start, end) => {
    if (attachedTo === 'StartEndDates' && start.toDateString() === end.toDateString()) {
      setMinEndTime({
        hour: start.getHours(),
        minute: end.getHours() <= start.getHours() ? start.getMinutes() : undefined
      });
    } else {
      // In case when user select min/max date in range:
      // Set max/min available time (hour + minute) values

      setMinStartTime(minDateTime && start.toDateString() === minDateTime.toDateString() ? {
        hour: minDateTime.getHours(),
        minute: start.getHours() <= minDateTime.getHours() ? minDateTime.getMinutes() : undefined
      } : undefined);
      setMinEndTime(minDateTime && end.toDateString() === minDateTime.toDateString() ? {
        hour: minDateTime.getHours(),
        minute: end.getHours() <= minDateTime.getHours() ? minDateTime.getMinutes() : undefined
      } : undefined);
      setMaxStartTime(maxDateTime && start.toDateString() === maxDateTime.toDateString() ? {
        hour: maxDateTime.getHours(),
        minute: end.getHours() >= maxDateTime.getHours() ? maxDateTime.getMinutes() : undefined
      } : undefined);
      setMaxEndTime(maxDateTime && end.toDateString() === maxDateTime.toDateString() ? {
        hour: maxDateTime.getHours(),
        minute: end.getHours() >= maxDateTime.getHours() ? maxDateTime.getMinutes() : undefined
      } : undefined);
    }
  }, [attachedTo, maxDateTime, minDateTime]);
  const getStartDateTimeWithDelta = start => {
    let startDateTimeWithDelta = new Date(start);
    if (deltaHours && deltaHours > 0) {
      const endOfTheStartDay = new Date(start);
      endOfTheStartDay.setHours(23, 59, 0, 0);
      startDateTimeWithDelta.setTime(start.getTime() + deltaHours * 60 * 60 * 1000);
      startDateTimeWithDelta = (0, _dates.restrictToMaxDate)(startDateTimeWithDelta, (0, _dates.restrictToMinuteStep)(endOfTheStartDay, minutesStep, false));
      startDateTimeWithDelta = (0, _dates.restrictToMaxDate)(startDateTimeWithDelta, maxDateTime);
    }
    return startDateTimeWithDelta;
  };
  const handleRangeDateChange = (startDate, endDate) => {
    setCurrentRangeDates([startDate ?? null, endDate ?? null]);
    if (startDate) {
      updateDates(startDate, endDate ?? startDate);
    } else if (endDate) {
      updateDates(startDate ?? endDate, endDate);
    }
  };
  const initDates = (0, _react.useCallback)(() => {
    startDateTimestamp.current = startDateTime.getTime();
    endDateTimestamp.current = endDateTime.getTime();
    setCurrentStartDateTime(startDateTime);
    setCurrentEndDateTime(endDateTime);
    setCurrentRangeDates([startDateTime, endDateTime]);
    updateMinMaxTimeValues(startDateTime, endDateTime);
  }, [endDateTime, startDateTime, updateMinMaxTimeValues]);
  const updateDates = (start, end) => {
    const newCurrentStartDateTime = new Date(currentStartDateTime);
    newCurrentStartDateTime.setDate(start.getDate());
    newCurrentStartDateTime.setMonth(start.getMonth());
    newCurrentStartDateTime.setFullYear(start.getFullYear());
    newCurrentStartDateTime.setSeconds(0, 0);
    let newCurrentEndDateTime = new Date(currentEndDateTime);
    newCurrentEndDateTime.setDate(end.getDate());
    newCurrentEndDateTime.setMonth(end.getMonth());
    newCurrentEndDateTime.setFullYear(end.getFullYear());
    newCurrentEndDateTime.setSeconds(0, 0);
    if (newCurrentEndDateTime <= newCurrentStartDateTime) {
      newCurrentEndDateTime = deltaHours ? getStartDateTimeWithDelta(newCurrentStartDateTime) : newCurrentStartDateTime;
    }
    setCurrentStartDateTime(newCurrentStartDateTime);
    setCurrentEndDateTime(newCurrentEndDateTime);
    updateMinMaxTimeValues(newCurrentStartDateTime, newCurrentEndDateTime);
  };
  const handleStartTimeChange = newCurrentStartDateTime => {
    let newCurrentEndDateTime = new Date(currentEndDateTime);
    if (newCurrentEndDateTime <= newCurrentStartDateTime) {
      newCurrentEndDateTime = deltaHours ? getStartDateTimeWithDelta(newCurrentStartDateTime) : newCurrentStartDateTime;
      setCurrentEndDateTime(newCurrentEndDateTime);
    }
    setCurrentStartDateTime(newCurrentStartDateTime);
    updateMinMaxTimeValues(newCurrentStartDateTime, newCurrentEndDateTime);
  };
  const handleEndTimeChange = newCurrentEndDateTime => {
    setCurrentEndDateTime(newCurrentEndDateTime);
    updateMinMaxTimeValues(currentStartDateTime, newCurrentEndDateTime);
  };
  const handleConfirm = () => {
    if (onChange) {
      onChange(currentStartDateTime, currentEndDateTime);
    }
  };
  const handleCancel = () => {
    initDates();
  };
  (0, _react.useEffect)(() => {
    if (startDateTimestamp.current !== startDateTime.getTime() || endDateTimestamp.current !== endDateTime.getTime()) {
      initDates();
    }
  }, [endDateTime, startDateTime, initDates]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-RangeDateTimePicker'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Menu.Menu, {
      defaultTitle: attachedTo === 'StartDate' ? getLabel('choose') + anchorSubTextStartDate : attachedTo === 'EndDate' ? getLabel('choose') + anchorSubTextEndDate : getLabel('choose_date_time'),
      isBoxCenteredToAnchor: true,
      anchorWidth: isMobileView ? 'auto' : 'fit-content',
      btnProps: btnProps,
      isWithActionButtons: true,
      isFullScreen: isMobileView,
      onConfirm: handleConfirm,
      onCancel: handleCancel,
      children: [dateTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-RangeDateTimePicker__inner-title'],
        children: dateTitle
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_RangeDatePicker.RangeDatePicker, {
        minDate: minDateTime,
        maxDate: maxDateTime,
        startDate: currentRangeDates?.[0] ?? undefined,
        endDate: currentRangeDates?.[1] ?? undefined,
        attachedTo: attachedTo,
        onChange: handleRangeDateChange
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-RangeDateTimePicker__time-container'],
        children: [(attachedTo === 'StartDate' || attachedTo === 'StartEndDates') && /*#__PURE__*/(0, _jsxRuntime.jsx)(_TimePickerArea.TimePickerArea, {
          dateTime: currentStartDateTime,
          minTime: minStartTime,
          maxTime: maxStartTime,
          minutesStep: minutesStep,
          title: startTimeTitle,
          onChange: handleStartTimeChange
        }), (attachedTo === 'EndDate' || attachedTo === 'StartEndDates') && /*#__PURE__*/(0, _jsxRuntime.jsx)(_TimePickerArea.TimePickerArea, {
          dateTime: currentEndDateTime,
          minTime: minEndTime,
          maxTime: maxEndTime,
          minutesStep: minutesStep,
          title: endTimeTitle,
          onChange: handleEndTimeChange
        })]
      })]
    })
  });
};
exports.RangeDateTimePicker = RangeDateTimePicker;